export default () => {
    const togglePopup = $('.toggle-popup');
    const closePopup = $('.close-popup');
    const html = $('body');
    const body = $('html');

    $('body').on('click', '.toggle-popup', function () {
        const popup = $('.overlay-popup')
        const thisToggler = $(this)
        popup.each(function () {
            if ($(this).data('id') == thisToggler.data('id')) {
                $(this).toggleClass('active')
                html.toggleClass('popup-locked')
                body.toggleClass('popup-locked')
            }
        })
    })

    closePopup.on('click', function () {
        const openPopup = $('.overlay-popup');
        openPopup.removeClass('active')
        html.removeClass('popup-locked')
        body.removeClass('popup-locked')
    })
}



// WEBPACK FOOTER //
// ./scripts/layout/popup.js